import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import singleChoice from '@/views/questionnaire/customerManage/questionnaireList/components/singleChoice.vue';
import tableControl from '@/views/questionnaire/customerManage/questionnaireList/components/tableControl.vue';
import multipleChoice from '@/views/questionnaire/customerManage/questionnaireList/components/multipleChoice.vue';
import dateControl from '@/views/questionnaire/customerManage/questionnaireList/components/dateControl.vue';
import dropDownSelect from '@/views/questionnaire/customerManage/questionnaireList/components/dropDownSelect.vue';
import signModel from '@/views/questionnaire/customerManage/questionnaireList/components/signModel.vue'; //签名组件
import formControlItem from '@/components/examine/formControlItem.vue';
import paragraphModel from '@/views/questionnaire/customerManage/questionnaireList/components/paragraphModel.vue'; //段落
import enclosureModel from '@/views/questionnaire/customerManage/questionnaireList/components/enclosureModel.vue'; //附件
import singleLineMultilineModel from '@/views/questionnaire/customerManage/questionnaireList/components/singleLineMultilineModel.vue'; //单行文本and多行文本
import topTitle from '@/components/title';
import { mapState } from 'vuex';
import formItemMixin from '@/mixins/formItemMixin';
import { checkEmail } from '@/utils/validate';
export default {
  props: {
    sharedNodeInfo: {
      type: Array,
      default() {
        return [];
      }
    },
    echoNodeIsEdit: {
      type: Boolean,
      default: false //false不可以编辑true可编辑
    },
    policyInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    showPolicyInfo: {
      type: Boolean,
      default: true
    }
  },
  mixins: [formItemMixin],
  components: {
    singleChoice,
    tableControl,
    multipleChoice,
    dateControl,
    dropDownSelect,
    signModel,
    paragraphModel,
    enclosureModel,
    topTitle,
    singleLineMultilineModel,
    formControlItem
  },
  computed: {
    ...mapState({
      countriesData: state => state.quiretionnaire.countriesData,
      provinceFirstLevel: state => state.quiretionnaire.provinceFirstLevel,
      provinceData: state => state.quiretionnaire.provinceData,
      provinceArea: state => state.quiretionnaire.provinceArea,
      logisticsData: state => state.quiretionnaire.logisticsData,
      bankData: state => state.quiretionnaire.bankData
    })
  },
  created() {
    //处理数据结构 mark值  回显值 以及关联关系
    this.sharedNodeInfo.forEach(item1 => {
      if (item1.method === 'ORSIGN') {
        // 审核方式ORSIGN 或签
        item1.editableArea && Array.isArray(item1.editableArea) && item1.editableArea.forEach(item2 => {
          item2.form && Array.isArray(item2.form) && item2.form.forEach(control => {
            if (control.controlType === 'control') {
              var _control$control;
              control.control.mark = (_control$control = control.control) === null || _control$control === void 0 ? void 0 : _control$control.mark.replace('d.', 'd_');
              this.setEchoForm(control.control);
            } else {
              control.mark = control.mark.replace('d.', 'd_');
              let groupControl = control.control;
              groupControl.forEach(item => {
                item.mark = item.mark.replace('d.', 'd_');
                //设置回显值
                this.setEchoForm(item);
              });
            }
            //设置控件显隐 以及处理关联关系
            this.setAssociationInfo(control);
          });
        });
      } else {
        // 审核方式COUNTERSIGN 会签
        item1.editableArea && Array.isArray(item1.editableArea) && item1.editableArea.forEach(item => {
          console.log(item, item.editableArea, 'item会签');
          item.editableArea && Array.isArray(item.editableArea) && item.editableArea.forEach(item2 => {
            item2.form && Array.isArray(item2.form) && item2.form.forEach(control => {
              console.log(control.control.mark, '----');
              if (control.controlType === 'control') {
                var _control$control2;
                control.control.mark = (_control$control2 = control.control) === null || _control$control2 === void 0 ? void 0 : _control$control2.mark.replace('d.', 'd_');
                this.setEchoForm(control.control);
              } else {
                control.mark = control.mark.replace('d.', 'd_');
                let groupControl = control.control;
                groupControl.forEach(item => {
                  item.mark = item.mark.replace('d.', 'd_');
                  //设置回显值
                  this.setEchoForm(item);
                });
              }
              //设置控件显隐 以及处理关联关系
              this.setAssociationInfo(control);
            });
          });
        });
      }
    });
    console.log(this.sharedNodeInfo, 'this.sharedNodeInfo');
    this.formatRules();
  },
  data() {
    return {
      formData: {},
      showControl: {},
      rules: {},
      associationInfo: {},
      vidateStatus: true,
      submitData: []
    };
  },
  methods: {
    valueChangeValidate(key) {
      this.$refs.form.validateField(key);
    },
    setAssociationInfo(control) {
      var _controlItem$associat;
      //设置关联关系
      let mark = control.controlType === 'control' ? control.control.mark : control.mark;
      let controlItem = control.controlType === 'control' ? control.control : control;
      if ((controlItem === null || controlItem === void 0 || (_controlItem$associat = controlItem.association) === null || _controlItem$associat === void 0 || (_controlItem$associat = _controlItem$associat.association) === null || _controlItem$associat === void 0 ? void 0 : _controlItem$associat.length) > 0) {
        let key = controlItem.association.association[0].hideControl.replace('d.', 'd_');
        let value = controlItem.association.association[0];
        value.targetKey = mark;
        if (Array.isArray(this.associationInfo[key])) {
          this.associationInfo[key].push(value);
        } else {
          this.associationInfo[key] = [value];
        }
        this.$set(this.showControl, mark, false);
      } else {
        this.$set(this.showControl, mark, true);
      }
    },
    // setEchoForm(controlItem) {
    //   //设置表单回显值
    //   if (controlItem.partsType === 'multipleChoice') {
    //     let value = controlItem.value || [];
    //     this.$set(this.formData, controlItem.mark, value);
    //   } else if (controlItem.partsType === 'dropDown') {
    //     let valueObj = controlItem.value;
    //     let value = valueObj ? valueObj.codeValue : undefined;
    //     this.$set(this.formData, controlItem.mark, value);
    //   } else {
    //     this.$set(this.formData, controlItem.mark, controlItem.value || undefined);
    //   }
    // },
    // validateEmail(rules, value, callback) {
    //   if (value && !checkEmail(value)) {
    //     callback(new Error(this.$t('邮箱格式有误，请重新填写')));
    //   }
    //   callback();
    // },
    formatDropResourceMap() {
      //生成下拉资源的map对象 用来获取下拉选择的选项label传给后端
      const loop = (data, obj) => {
        data.forEach(item => {
          obj[item.id] = item.name;
          if (item.children) {
            loop(item.children, obj);
          }
        });
        return obj;
      };
      this.countriesDataMap = loop(this.countriesData, {});
      this.provinceFirstLevelObj = loop(this.provinceFirstLevel, {});
      this.provinceDataObj = loop(this.provinceData, {});
      this.provinceAreaObj = loop(this.provinceArea, {});
      this.logisticsDataObj = loop(this.logisticsData, {});
      this.bankDataObj = loop(this.bankData, {});
    },
    formatRules() {
      //生成校验规则
      this.sharedNodeInfo.forEach(item => {
        item.editableArea && Array.isArray(item.editableArea) && item.editableArea.forEach(item2 => {
          item2.form && Array.isArray(item2.form) && item2.form.forEach(item3 => {
            if (item3.controlType === 'control') {
              let rules = this.generateValidateRule(item3.control);
              if (rules.length > 0) {
                this.$set(this.rules, item3.control.mark, rules);
              }
            } else if (item3.controlType === 'controlGroup') {
              item3.control.forEach(item4 => {
                let rules = this.generateValidateRule(item4);
                if (rules.length > 0) {
                  this.$set(this.rules, item4.mark, rules);
                }
              });
            }
          });
        });
      });
      console.log(this.rules, 'this.rules');
    },
    changeControlShow(value, key) {
      this.$set(this.showControl, key, value);
    },
    handleDropDownData(value, item) {
      //下拉选择的value格式处理
      if (!value) {
        return {
          textValue: [],
          codeValue: []
        };
      }
      const generaterText = mapObj => {
        let textValue = [];
        value.forEach(valueArr => {
          let text = '';
          if (Array.isArray(valueArr) && valueArr.length > 0) {
            //多选
            valueArr.forEach((value, index) => {
              if (index === valueArr.length - 1) {
                text = text + mapObj[value];
              } else {
                text = text + mapObj[value] + '/';
              }
            });
          } else {
            //单选
            text = mapObj[valueArr];
          }
          textValue.push(text);
        });
        return textValue;
      };
      let textData = [];
      let dataType = item.type.type;
      if (dataType === 'provinceArea') {
        textData = generaterText(this.provinceAreaObj);
      } else if (dataType === 'province') {
        textData = generaterText(this.provinceDataObj);
      } else if (dataType === 'provinceFirstLevel') {
        textData = generaterText(this.provinceFirstLevelObj);
      } else if (dataType === 'country') {
        textData = generaterText(this.countriesDataMap);
      } else if (dataType === 'bank') {
        textData = generaterText(this.bankDataObj);
      } else if (dataType === 'logistics') {
        textData = generaterText(this.logisticsDataObj);
      } else if (dataType === 'custom') {
        const loop = (data, obj) => {
          data.forEach(item => {
            obj[item.id] = item.name;
            if (item.children) {
              loop(item.children, obj);
            }
          });
          return obj;
        };
        let mapObj = loop(item.dataList, {});
        textData = generaterText(mapObj);
      }
      return {
        textValue: textData,
        codeValue: value
      };
    },
    // handleControlValue(controlItem) {
    //   //处理控件的value值
    //   if (controlItem.partsType === 'table') {
    //     // controlItem.value = this.$refs[`table${controlItem.mark}`][0].formDataArray;
    //   } else if (controlItem.partsType === 'dropDown') {
    //     let value = this.formData[controlItem.mark];
    //     controlItem.value = this.handleDropDownData(value, controlItem);
    //   } else if (controlItem.partsType === 'date') {
    //     //日期组件处理格式
    //     console.log(controlItem, 'controlItem');
    //     let value = this.formData[controlItem.mark];
    //     controlItem.value = value ? moment(value).format(controlItem.dateType) : '';
    //   } else {
    //     console.log(controlItem, this.formData[controlItem.mark], 'controlItem');
    //     controlItem.value = this.formData[controlItem.mark] || '';
    //   }
    //   controlItem.mark = controlItem.mark.replace('d_', 'd.');
    // },
    onSubmit() {
      let tableValidateStatus = this.validateTable();
      if (!tableValidateStatus) {
        this.vidateStatus = false;
        return;
      }
      this.formatDropResourceMap();
      this.$refs.form.validate(valid => {
        this.vidateStatus = valid;
        if (valid) {
          this.generateTableData();
          this.submitData = JSON.parse(JSON.stringify(this.sharedNodeInfo));
          console.log(this.submitData, this.sharedNodeInfo, 'this.submitData');
          this.submitData.forEach((item, index) => {
            if (item.isEdit === false) {
              this.submitData.splice(index, 1);
            } else {
              item.editableArea && Array.isArray(item.editableArea) && item.editableArea.forEach(nodeItem => {
                nodeItem.form.forEach(controlItem => {
                  if (controlItem.controlType === 'controlGroup') {
                    controlItem.control.forEach(item => {
                      this.handleControlValue(item);
                    });
                  } else {
                    this.handleControlValue(controlItem.control);
                  }
                });
              });
            }
          });
        }
      });
    },
    validateTable() {
      //验证表格数据
      this.sharedNodeInfo.forEach(item => {
        if (item.method === 'COUNTERSIGN') {
          // 会签
          item.editableArea && Array.isArray(item.editableArea) && item.editableArea.forEach(item2 => {
            item2.editableArea && Array.isArray(item2.editableArea) && item2.editableArea.forEach(nodeItem => {
              nodeItem.form && Array.isArray(nodeItem.form) && nodeItem.form.forEach(controlItem => {
                if (controlItem.controlType === 'controlGroup') {
                  //控件组
                  controlItem.control.forEach(item => {
                    if (item.partsType === 'table' && this.showControl[item.mark]) {
                      this.$refs[`control${item.mark}`][0].validateTable();
                    }
                  });
                } else if (controlItem.control.partsType === 'table' && this.showControl[controlItem.control.mark]) {
                  this.$refs[`control${controlItem.control.mark}`][0].validateTable();
                }
              });
            });
          });
        } else {
          // 或签
          // console.log(item, '---------或签提交表单校验-----------');
          item.editableArea && Array.isArray(item.editableArea) && item.editableArea.forEach(nodeItem => {
            nodeItem.form && Array.isArray(nodeItem.form) && nodeItem.form.forEach(controlItem => {
              if (controlItem.controlType === 'controlGroup') {
                //控件组
                controlItem.control.forEach(item => {
                  if (item.partsType === 'table' && this.showControl[item.mark]) {
                    this.$refs[`control${item.mark}`][0].validateTable();
                  }
                });
              } else if (controlItem.control.partsType === 'table' && this.showControl[controlItem.control.mark]) {
                this.$refs[`control${controlItem.control.mark}`][0].validateTable();
              }
            });
          });
        }
      });
      let validateStatus = true;
      for (let m = 0; m < this.sharedNodeInfo.length; m++) {
        let formItem = this.sharedNodeInfo[m];
        // console.log(formItem, '------formItem------------');
        if (formItem.method === 'COUNTERSIGN') {
          formItem.editableArea.forEach(item => {
            item.editableArea && Array.isArray(item.editableArea) && item.editableArea.forEach(forms => {
              forms.form && Array.isArray(forms.form) && forms.form.forEach(form => {
                if (form.controlType === 'controlGroup') {
                  //控件组
                  form.control.forEach(control => {
                    if (control.partsType === 'table' && this.showControl[control.mark]) {
                      if (!this.$refs[`control${item.mark}`][0].$refs[`table${item.mark}`].validateStatus) {
                        validateStatus = false;
                      }
                      if (!validateStatus) {
                        return;
                      }
                    }
                  });
                } else if (form.control.partsType === 'table' && this.showControl[form.control.mark]) {
                  if (!this.$refs[`control${controlItem.control.mark}`][0].$refs[`table${controlItem.control.mark}`].validateStatus) {
                    validateStatus = false;
                  }
                }
                if (!validateStatus) {
                  return;
                }
              });
              if (!validateStatus) {
                return;
              }
            });
          });
        } else {
          let length = formItem.editableArea && Array.isArray(formItem.editableArea) ? formItem.editableArea.length : 0;
          for (let i = 0; i < length; i++) {
            let nodeItem = formItem.editableArea[i];
            for (let j = 0; j < nodeItem.form.length; j++) {
              let controlItem = nodeItem.form[j];
              if (controlItem.controlType === 'controlGroup') {
                //控件组
                for (let k = 0; k < controlItem.control.length; k++) {
                  let item = controlItem.control[k];
                  if (item.partsType === 'table' && this.showControl[item.mark]) {
                    if (!this.$refs[`control${item.mark}`][0].$refs[`table${item.mark}`].validateStatus) {
                      validateStatus = false;
                    }
                    if (!validateStatus) {
                      break;
                    }
                  }
                }
              } else if (controlItem.control.partsType === 'table' && this.showControl[controlItem.control.mark]) {
                if (!this.$refs[`control${controlItem.control.mark}`][0].$refs[`table${controlItem.control.mark}`].validateStatus) {
                  validateStatus = false;
                }
              }
              if (!validateStatus) {
                break;
              }
            }
            if (!validateStatus) {
              break;
            }
          }
        }
      }
      return validateStatus;
    },
    generateTableData() {
      this.sharedNodeInfo.forEach(item => {
        if (item.method === 'ORSIGN') {
          item.editableArea && Array.isArray(item.editableArea) && item.editableArea.forEach(nodeItem => {
            this.geneTableDataInner(nodeItem);
          });
        } else {
          item.editableArea && Array.isArray(item.editableArea) && item.editableArea.forEach(nodeItem => {
            var _nodeItem$editableAre;
            Array.isArray(nodeItem.editableArea) && ((_nodeItem$editableAre = nodeItem.editableArea) === null || _nodeItem$editableAre === void 0 ? void 0 : _nodeItem$editableAre.forEach(nodeItem2 => {
              this.geneTableDataInner(nodeItem2);
            }));
          });
        }
      });
    },
    geneTableDataInner(nodeItem) {
      nodeItem.form && nodeItem.form.forEach(controlItem => {
        var _controlItem$control;
        if (controlItem.controlType === 'controlGroup') {
          controlItem.control.forEach(item1 => {
            if (item1.partsType === 'table' && this.showControl[controlItem.mark]) {
              this.$refs[`control${item1.mark}`][0].generationData();
            }
          });
        } else if (((_controlItem$control = controlItem.control) === null || _controlItem$control === void 0 ? void 0 : _controlItem$control.partsType) === 'table' && this.showControl[controlItem.control.mark]) {
          this.$refs[`control${controlItem.control.mark}`][0].generationData();
        }
      });
    }
  }
};